// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Odds = your entries / total entries * 100`
};

const de_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Chancen = Ihre Einträge / Gesamte Einträge * 100`
};

const es_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Probabilidad = tus entradas / entradas totales * 100`
};

const fr_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Probabilité = vos entrées / entrées totales * 100`
};

const fi_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Todennäköisyys = sinun osallistumisesi / kaikki osallistumiset * 100`
};

const ja_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `確率 = あなたのエントリー数 / 総エントリー数 * 100`
};

const nl_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Kansen = uw inzendingen / totale inzendingen * 100`
};

const pt_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Probabilidade = suas entradas / entradas totais * 100`
};

const ro_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Șanse = intrările tale / intrările totale * 100`
};

const th_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `โอกาส = การเข้าร่วมของคุณ / การเข้าร่วมทั้งหมด * 100`
};

const ur_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `امکانات = آپ کی انٹریز / کل انٹریز * 100`
};

const zh_hant1_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `機率 = 您的參賽次數 / 總參賽次數 * 100`
};

const da_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Odds = dine indgange / totale indgange * 100`
};

const it_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Probabilità = le tue voci / voci totali * 100`
};

const vn_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Tỷ lệ = lượt tham gia của bạn / tổng lượt tham gia * 100`
};

const ko_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `확률 = 당신의 응모 수 / 총 응모 수 * 100`
};

const tr_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Olasılık = girdileriniz / toplam girdiler * 100`
};

const lv_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Iespējas = jūsu ieraksti / kopējie ieraksti * 100`
};

const ar_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `الاحتمالات = مشاركاتك / إجمالي المشاركات * 100`
};

const bs_widget_leaderboard_odds_calculation = /** @type {(inputs: {}) => string} */ () => {
	return `Šanse = vaša učešća / ukupna učešća * 100`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_odds_calculation = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_odds_calculation(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_odds_calculation", locale)
	if (locale === "en") return en_widget_leaderboard_odds_calculation(inputs)
	if (locale === "de") return de_widget_leaderboard_odds_calculation(inputs)
	if (locale === "es") return es_widget_leaderboard_odds_calculation(inputs)
	if (locale === "fr") return fr_widget_leaderboard_odds_calculation(inputs)
	if (locale === "fi") return fi_widget_leaderboard_odds_calculation(inputs)
	if (locale === "ja") return ja_widget_leaderboard_odds_calculation(inputs)
	if (locale === "nl") return nl_widget_leaderboard_odds_calculation(inputs)
	if (locale === "pt") return pt_widget_leaderboard_odds_calculation(inputs)
	if (locale === "ro") return ro_widget_leaderboard_odds_calculation(inputs)
	if (locale === "th") return th_widget_leaderboard_odds_calculation(inputs)
	if (locale === "ur") return ur_widget_leaderboard_odds_calculation(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_odds_calculation(inputs)
	if (locale === "da") return da_widget_leaderboard_odds_calculation(inputs)
	if (locale === "it") return it_widget_leaderboard_odds_calculation(inputs)
	if (locale === "vn") return vn_widget_leaderboard_odds_calculation(inputs)
	if (locale === "ko") return ko_widget_leaderboard_odds_calculation(inputs)
	if (locale === "tr") return tr_widget_leaderboard_odds_calculation(inputs)
	if (locale === "lv") return lv_widget_leaderboard_odds_calculation(inputs)
	if (locale === "ar") return ar_widget_leaderboard_odds_calculation(inputs)
	if (locale === "bs") return bs_widget_leaderboard_odds_calculation(inputs)
	return "widget_leaderboard_odds_calculation"
};